import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { HealthCheckTabs } from './components/health-check-tabs';
import { SlideInModal } from 'components/slide-in-modal';
import { Spinner } from '@purpurds/purpur/spinner';
import { spacing } from 'theme/spacing';
import { purpurColorPurple800 } from '@purpurds/tokens/color/variables';
import { Icon } from '@purpurds/purpur/icon';
import styled from 'styled-components';
import { icons } from 'theme/icons';
import { Loader } from 'components';
import { useHealthCheck } from '../api/use-health-check';
import { ErrorNotification } from 'components/error-notification';
const StyledIcon = styled(Icon) `
  color: ${purpurColorPurple800};
  cursor: pointer;
  margin: 0 ${spacing.spacing4} ${spacing.spacing4} 0;
`;
const DeviceHealthCheckContainer = ({ device, onClose, display, languageStrings, }) => {
    var _a;
    const { healthCheck, isLoading, isFetching, error, refetch, } = useHealthCheck(device === null || device === void 0 ? void 0 : device.pollUrl);
    useEffect(() => {
        if (device === null || device === void 0 ? void 0 : device.pollUrl)
            refetch();
    }, [device]);
    return (_jsxs(SlideInModal, { display: display, onClose: onClose, mainHeading: device === null || device === void 0 ? void 0 : device.description, leftIcon: isFetching && !isLoading ? (_jsx(Spinner, { size: "xs" })) : (_jsx(StyledIcon, { svg: icons.sync, size: 'md', onClick: () => refetch() })), children: [isFetching && _jsx(Loader, {}), !isFetching && (error || !healthCheck.success) && (_jsx(ErrorNotification, { title: languageStrings.SORRY, text: healthCheck.errorDescription || error })), !isFetching && healthCheck.success && (_jsx(HealthCheckTabs, { categories: (_a = healthCheck.categories) !== null && _a !== void 0 ? _a : [] }))] }));
};
const mapStateToProps = (state) => ({
    languageStrings: state.NOB.FEEDBACKS,
});
export default connect(mapStateToProps)(DeviceHealthCheckContainer);
